import React from 'react'

import { IconProps, DynamicIconProps } from '../../types'
import {
  InputValidIconSmall as HmIconSmall,
  InputValidIconMedium as HmIconMedium,
  InputValidIcon as HmIcon,
} from '../brand/hm/InputValidIcon'
import {
  InputValidIconSmall as HmGroupIconSmall,
  InputValidIconMedium as HmGroupIconMedium,
  InputValidIcon as HmGroupIcon,
} from '../brand/hmGroup/InputValidIcon'
import {
  InputValidIconSmall as MonkiIconSmall,
  InputValidIconMedium as MonkiIconMedium,
  InputValidIcon as MonkiIcon,
} from '../brand/monki/InputValidIcon'
import {
  InputValidIconSmall as NorthstarIconSmall,
  InputValidIconMedium as NorthstarIconMedium,
  InputValidIcon as NorthstarIcon,
} from '../brand/northstar/InputValidIcon'
import {
  InputValidIconSmall as OSIconSmall,
  InputValidIconMedium as OSIconMedium,
  InputValidIcon as OSIcon,
} from '../brand/otherStories/InputValidIcon'

export const InputValidIconSmall: React.FC<IconProps> = (props) => {
  switch (process.env.BRAND) {
    case 'hmGroup':
      return <HmGroupIconSmall {...props} />
    case 'monki':
      return <MonkiIconSmall {...props} />
    case 'northstar':
      return <NorthstarIconSmall {...props} />
    case 'otherStories':
      return <OSIconSmall {...props} />
    case 'hm':
    default:
      return <HmIconSmall {...props} />
  }
}

export const InputValidIconMedium: React.FC<IconProps> = (props) => {
  switch (process.env.BRAND) {
    case 'hmGroup':
      return <HmGroupIconMedium {...props} />
    case 'monki':
      return <MonkiIconMedium {...props} />
    case 'northstar':
      return <NorthstarIconMedium {...props} />
    case 'otherStories':
      return <OSIconMedium {...props} />
    case 'hm':
    default:
      return <HmIconMedium {...props} />
  }
}

export const InputValidIcon: React.FC<DynamicIconProps> = (props) => {
  switch (process.env.BRAND) {
    case 'hmGroup':
      return <HmGroupIcon {...props} />
    case 'monki':
      return <MonkiIcon {...props} />
    case 'northstar':
      return <NorthstarIcon {...props} />
    case 'otherStories':
      return <OSIcon {...props} />
    case 'hm':
    default:
      return <HmIcon {...props} />
  }
}

export default InputValidIcon
